<template>
  <div>
    <v-autocomplete
      outlined
      v-if="readonly === false"
      dense
      v-model="select"
      :items="lista"
      item-text="Descripcion_plan"
      item-value="id_plan"
      label="Plan"
      persistent-hint
      return-object
      @change="$emit('input', select.id_plan)"
      hide-details
    ></v-autocomplete>
    <v-text-field
      outlined
      dense
      label="Plan"
      v-if="readonly === true && !texto"
      readonly
      filled
      :value="select.Descripcion_plan"
      hide-details
    ></v-text-field>
    <h3 v-if="texto">Plan: {{ select.Descripcion_plan }}</h3>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  props: {
    value: Number,
    readonly: {
      type: Boolean,
      default: false
    },
    texto: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      select: {
        id_plan: 0,
        Descripcion_plan: ''
      }
    }
  },
  computed: {
    ...mapState('planes', ['Lista']),
    lista: function () {
      let l = [
        {
          id_plan: -1,
          Descripcion_plan: ' --Seleccione-- '
        },
        {
          id_plan: 0,
          Descripcion_plan: 'TODOS'
        },
        ...this.Lista
      ]
      return l
    }
  },
  methods: {
    seleccionar(id) {
      if (id) {
        let pr = this.lista.find((x) => x.id_plan == id)
        if (pr) {
          this.select = pr
        } else {
          this.seleccionar('0')
        }
      } else {
        this.seleccionar('-1')
      }
    }
  },
  async mounted() {
    let id = this.value
    this.seleccionar(id)
  },
  watch: {
    value: function (newVal, oldVal) {
      this.seleccionar(newVal)
    }
  }
}
</script>

<style></style>
